module.exports = __webpack_public_path__ + "basket.svg?dbf8678451e044ecf95c4e6c4358e08a";